<template lang='pug'>
.content.chat-content
  .row.chat-body
    .col-md-12
      .header Chat
      .card
        //- .card-content
</template>

<script>
// import gql from 'graphql-tag'
// import graphql from '../Model/graphql'
export default {}
</script>

<style lang="scss" scoped>
.chat-content {
  padding-top: 20px !important;
}
.chat-body {
  .header {
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    color: #5F6468;
  }
}
@media (max-width: 414px) {
  .chat-content {
    padding-top: 30px !important;
  }
  .chat-body {}
}
</style>



// WEBPACK FOOTER //
// index.vue?26844626